import { render, staticRenderFns } from "./DropdownCheckbox.vue?vue&type=template&id=15e55544&scoped=true"
import script from "./DropdownCheckbox.vue?vue&type=script&lang=js"
export * from "./DropdownCheckbox.vue?vue&type=script&lang=js"
import style0 from "./DropdownCheckbox.vue?vue&type=style&index=0&id=15e55544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e55544",
  null
  
)

export default component.exports